define('models/vertical',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.Vertical = T1Model.extend({
    url: "vertical/",
    fixture: "-vertical"
  });
  return T1.Models.Vertical;
});
